import { useState } from "react";
import useDebounce from "./useDebounce";

export default function useDebounceSearch(debounceDelay = 500) {
  const [search, setSearch] = useState("");
  const debounceValue = useDebounce(search, debounceDelay);

  return { search, setSearch, debounceValue };
}
